<template>
  <div class="activities-list">
    <div class="activity" v-if="loading">
      Chargement de l'activité de l'utilisateur
    </div>
    <div class="activity" v-else-if="activities.length === 0">
      No activity for this user
    </div>
    <div class="activity" v-else v-for="activity in activities" :key="activity.id">
      <div class="resume" v-if="activity.action && activity.action.name">
        <span class="name" v-if="activity.performer.nickname">{{ activity.performer.nickname }}</span>
        <span class="name" v-else>{{ activity.performer.fname }} {{ activity.performer.lname }}</span>
        <span class="action">{{ activity.action.name }}</span>
        <span class="points" v-if="activity.action.score > 0">pour {{ activity.action.score }} pts.</span>
      </div>

      <div class="resume badged" v-if="activity.achievement && activity.achievement.id">
        <span class="name" v-if="activity.performer.nickname">{{ activity.performer.nickname }}</span>
        <span class="name" v-else>{{ activity.performer.fname }} {{ activity.performer.lname }}</span>
        <span class="action">a débloqué le badge {{ activity.achievement.name }}</span>
        <span class="points" v-if="activity.achievement.score > 0">pour {{ activity.achievement.score }} pts.</span>
        <div class="badge">
          <img :src="activity.achievement.media.url" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HTTP from '@rocketfid/api'
import { mapGetters } from 'vuex'

export default {
  name: 'customer-activities-list',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      activities: [],
      loading: true
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    init () {
      this.getActivitiesByPage(0)
    },

    getActivitiesByPage (page) {
      HTTP.axios.get(process.env.API + '/user/' + this.id + '/activity/' + page + '/20/')
        .then((result) => {
          this.activities.push(...result.data)
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    }
  }
}

</script>

<style lang="scss" scoped>
.activity {
    padding: 12px;
    margin-bottom: 8px;
    display: grid;
    grid-template-columns: 1fr 40px;

    .name {
        font-weight: 600;
    }

    .resume.badged {
      position: relative;
      box-sizing: border-box;
      padding-right: 80px;
      .badge {
        position: absolute;
        top: 0;
        right: 0;
        width: 48px;
        height: 48px;
        img {
          height: 100%;
          width: 100%;;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/customers/customer-activities-list.vue